module.exports = __webpack_public_path__ + "static/img/97.d6cc579.png";